import { render, staticRenderFns } from "./NewReferenceSource.vue?vue&type=template&id=f01af652&"
import script from "./NewReferenceSource.vue?vue&type=script&lang=js&"
export * from "./NewReferenceSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports